import React, { Component } from "react";
import { connect } from "react-redux";

// Show notification bubble
class NotificationHeader extends Component {
  render() {
    if (this.props.newTaskNotification)
      return (
        <span
          style={{
            width: 8,
            height: 8,
            background: "#da6b36",
            borderRadius: "50%",
            float: "right"
          }}
        />
      );
    return null;
  }
}

const mapStateToProps = function(store) {
  return {
    newTaskNotification: store.appState.newTaskNotification
  };
};

export default connect(mapStateToProps)(NotificationHeader);


// WEBPACK FOOTER //
// ./src/components/views/utils/NotificationHeader.js